import React from "react";
/** Components Import */
import BasicCheckbox from "../Checkbox_Basic";

export default (props) => {
  return (
    <div>
      <BasicCheckbox
        value={props.value}
        onChange={(e) => {
          props.setValue(e.target.checked);
        }}
      />
    </div>
  );
};
